module.exports = __webpack_public_path__ + "static/media/send-icon-2.d59b2aac.svg";